import * as React from 'react';
import b_ from 'b_';
import { compose } from 'recompose';
import { Link } from 'shared/components/Link';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';

import './index.scss';

interface Props {}

type Enhanced = Props & InjectedTranslateProps;

const b = b_.with('idea-landing-finished');

const enhance = compose<Enhanced, Props>(translate);

class Finished extends React.Component<Enhanced> {
  render() {
    const { t } = this.props;
    return (
      <div className={b()} data-testid="finished-idea-section">
        <p className={b('text')}>{t('Idea is finished')}</p>
        <Link to="/investments" className={b('link')} data-testid="ideas-link">
          {t('View more ideas')}
        </Link>
      </div>
    );
  }
}
export default enhance(Finished);
